import { createContext, useState } from 'react';

export const GestionUsuariosContext = createContext();

export const GestionUsuariosProvider = ({ children }) => {
  const [centersFilter, setCentersFilter] = useState([]);
  const [inputValueSearch, setInputValueSearch] = useState(null);
  const [inputAfter, setInputAfter] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const data = {
    inputValueSearch,
    setInputValueSearch,
    inputAfter,
    setInputAfter,
    statusFilter,
    setStatusFilter,

    centersFilter,
    setCentersFilter,
  };

  return <GestionUsuariosContext.Provider value={data}>{children}</GestionUsuariosContext.Provider>;
};
